import image1 from "../assets/img/blog/blog-1.webp";
import image2 from "../assets/img/blog/blog-2.jpg";
import image3 from "../assets/img/blog/blog-3.webp";
import image4 from "../assets/img/blog/blog-1.webp";
import image5 from "../assets/img/blog/blog-2.jpg";
import image6 from "../assets/img/blog/blog-3.webp";

const blogData = [
    {
        number: '01',
        id: 'key-steps-to-ensure-a-smooth-building-process',
        date: '10',
        comment: '2',
        title: 'Key Steps to Ensure a Smooth Building Process',        
        image: image1,
        description: 'Top Mistakes to Avoid During Home Renovation Sustainability in construction is no longer optional it’s a necessity. Builders are increasingly adopting sustainable practices, which include using renewable resources, reducing waste, and incorporating energy-efficient systems. Techniques such as passive solar design, rainwater harvesting, and green roofs are gaining popularity. These methods not only reduce the environmental impact but also improve project efficiency.',
        delay: '0.4',
    },
    {
        number: '02',
        id: 'how-weather-can-impact-a-construction-project',
        date: '12',
        comment: '3',
        title: 'How Weather Can Impact a Construction Project',        
        image: image2,
        description: 'Weather conditions can significantly influence the timeline and quality of construction projects. Understanding seasonal changes, preparing for unexpected storms, and utilizing weather-resistant materials are critical for minimizing delays and ensuring safety during construction.',
        delay: '0.7',
    },
    {
        number: '03',
        id: 'how-to-choose-the-perfect-construction-company',
        date: '13',
        comment: '6',
        title: 'How to Choose the Perfect Construction Company',        
        image: image3,
        description: 'Choosing the right construction company is vital for a successful project. Consider factors such as experience, client reviews, portfolio, and their approach to communication. A reliable company ensures your project stays on budget and meets your expectations.',
        delay: '1',
    },
    {
        number: '04',
        id: 'top-mistakes-to-avoid-during-home-renovation',
        date: '15',
        comment: '7',
        title: 'Top Mistakes to Avoid During Home Renovation',        
        image: image4,
        description: 'Avoid common mistakes during home renovation by planning carefully, setting a realistic budget, and choosing skilled professionals. Neglecting these steps can lead to cost overruns, delays, and unsatisfactory results.',
        delay: '0.4',
    },
    {
        number: '05',
        id: 'how-to-maximize-space-in-your-commercial-building',
        date: '17',
        comment: '5',
        title: 'How to Maximize Space in Your Commercial Building',        
        image: image5,
        description: 'Maximizing space in commercial buildings requires smart design strategies such as modular furniture, open layouts, and multi-functional rooms. These approaches enhance usability and optimize the available area for better productivity.',
        delay: '0.7',
    },
    {
        number: '06',
        id: 'the-future-of-smart-homes-in-construction',
        date: '21',
        comment: '3',
        title: 'The Future of Smart Homes in Construction',        
        image: image6,
        description: 'Smart homes are shaping the future of construction with advanced technologies like IoT devices, automated systems, and energy-efficient solutions. These innovations offer convenience, sustainability, and enhanced living experiences for homeowners.',
        delay: '1',
    },
];

export default blogData;